
import React from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import WorkWeekForm from '../components/WorkWeekForm';
import ShiftManagementTab from '../components/ShiftManagementTab';
import EmployeeMapping from '../components/EmployeeMapping';
import EmployeeWithShift from '../components/EmployeeWithShift';

const tabList = [
  { label: 'Work Week', component: <WorkWeekForm /> },
  { label: 'Shifts', component: <ShiftManagementTab /> },
  { label: 'Employee Mapping', component: <EmployeeMapping /> },
  // Removed Employee With Shift tab; now shown in Employee Mapping
  //{ label: 'Edit Work Sheet', component: <div>Edit Work Sheet - Coming Soon</div> },
  //{ label: 'Add Shift', component: <ShiftForm /> },
];

const ShiftManagementPage: React.FC = () => {
  const [tab, setTab] = React.useState(0);
  const activeTab = tab >= 0 && tab < tabList.length ? tab : 0;

  React.useEffect(() => {
    if (tab >= tabList.length) {
      setTab(0);
    }
  }, [tab]);

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Attendance Shift Setting Management
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Main configuration hub for shift scheduling.
      </Typography>
      <Tabs
        value={activeTab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        {tabList.map((t) => (
          <Tab
            key={t.label}
            label={t.label}
            sx={{ textTransform: 'none' ,fontWeight: 700}}

          />
        ))}
      </Tabs>
      <Box>{tabList[activeTab]?.component}</Box>
    </Box>
  );
};

export default ShiftManagementPage;
